import AccountSetupService from './accountSetup';

export default AccountSetupService;
